import { useCallback } from 'react';
import { usePanels } from '../panels/usePanels';
import { aiAgentCenterPanelType } from '../dashboard/aiAgents/aiAgentCenterPanelType';

export const useOpenAgentsPanel = () => {
  const { maybeOpenPanel } = usePanels();

  return useCallback(() => {
    maybeOpenPanel({
      panelType: aiAgentCenterPanelType,
    });
  }, [maybeOpenPanel]);
};
